import { commonViewTexts } from '../common';

export const projectRootViewTexts = {
  tabs: {
    overview: '概要',
    projectImageList: `${commonViewTexts.blueprintData}管理`
  }
} as const;
